import { Resource } from '../../http/resource/resource.model';
// tslint:disable: variable-name

export class PopUp extends Resource {
  // id is inherited from Resource
  name: string;
  allow_close_popup: any;
  maximum_width: any;
  maximum_height: any;
  content: any;
  totvs_query: any;
  query: any;
  applicantData: any;
  use_totvs_oracle: boolean;
  client_id: number;
  edited_by: string;
  updated_at: string;
}
